import { render, staticRenderFns } from "./Contact2.vue?vue&type=template&id=c814bcda&scoped=true&"
import script from "./Contact2.vue?vue&type=script&lang=js&"
export * from "./Contact2.vue?vue&type=script&lang=js&"
import style0 from "./Contact2.vue?vue&type=style&index=0&id=c814bcda&prod&scoped=true&lang=css&"
import style1 from "./Contact2.vue?vue&type=style&index=1&id=c814bcda&prod&scoped=true&lang=css&"
import style2 from "./Contact2.vue?vue&type=style&index=2&id=c814bcda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c814bcda",
  null
  
)

export default component.exports